import { render, staticRenderFns } from "./ProfileParticipantTab.vue?vue&type=template&id=753522ab"
import script from "./ProfileParticipantTab.vue?vue&type=script&lang=js"
export * from "./ProfileParticipantTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports